import BundleLoader from './BundleLoader';

export default BundleLoader;
